import { TFunction } from 'i18next'

import { Feature, Offer } from '@wwt/entities/search-response'

import { TabValues } from '../types'
import { RemoteSection } from '../ui/RoomInfoTabs'
import { extractRemoteTabNames } from './extractRemoteTabNames'

export const generateRemoteTabs = (
	features: Feature[],
	offer: Offer | null,
	t: TFunction<'room-page'>
): TabValues[] => {
	const remoteTabNames = extractRemoteTabNames(features)
	const remoteTabs: TabValues[] = remoteTabNames.map(tabName => ({
		label: tabName,
		props: { tabName, offer },
		component: RemoteSection,
		hint: t('tabHint', { tabName: tabName })
	}))

	return remoteTabs
}
